import React from 'react';
import { useSelector } from 'react-redux';
import {
  useNonogramPuzzleDaily,
  useNonogramPuzzleById,
  useNonogramPuzzleBySize,
} from '@games/api';
import { selectAuthUser } from '@games/ui';
import PuzzleWrapper from './PuzzleWrapper';
import { useAppDispatch } from '../../../redux/store';
import { setPuzzle } from '../../../redux/puzzle-slice';

interface PuzzleByIdProps {
  id: number;
}

export const PuzzleById: React.FC<PuzzleByIdProps> = ({ id }) => {
  const [{ loading, error, data }] = useNonogramPuzzleById(id);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (data) {
      dispatch(setPuzzle(data));
    }
  }, [data, dispatch]);

  return <PuzzleWrapper loading={loading} error={error} puzzle={data} />;
};

interface PuzzleBySizeProps {
  size: number;
}

export const PuzzleBySize: React.FC<PuzzleBySizeProps> = ({ size }) => {
  const [{ loading, error, data }] = useNonogramPuzzleBySize(size);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (data) {
      dispatch(setPuzzle(data));
    }
  }, [data, dispatch]);

  return <PuzzleWrapper loading={loading} error={error} puzzle={data} />;
};

interface PuzzleDailyProps {
  date?: string;
}

export const PuzzleDaily: React.FC<PuzzleDailyProps> = ({ date }) => {
  const [{ loading, error, data }] = useNonogramPuzzleDaily(date);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (data) {
      dispatch(setPuzzle(data));
    }
  }, [data, dispatch]);

  return <PuzzleWrapper loading={loading} error={error} puzzle={data} isDaily date={date} />;
};

export interface PuzzleQueryProps {
  id?: number;
  size?: number;
  isDaily?: boolean;
  date?: string;
}

const PuzzleQuery: React.FC<PuzzleQueryProps> = ({
  id,
  size,
  isDaily,
  date,
}) => {
  const user = useSelector(selectAuthUser);
  if (isDaily) {
    return <PuzzleDaily date={date} />;
  }
  if (id) {
    return <PuzzleById id={id} />;
  }
  if (size) {
    return <PuzzleBySize size={size} />;
  }
  if (user?.nonogramSize) {
    return <PuzzleBySize size={user.nonogramSize} />;
  }
  return <PuzzleBySize size={10} />;
};

export default PuzzleQuery;
